export const messages = Object.freeze({
    connid_whitelist_is_not_enabled: 'Please enable the user whitelist first.',
    not_sysadmin: 'Only system administrators can perform this action.',
    oid_is_none: 'A required organization value is missing from the request.',
    org_deleted: 'The organization has been deleted.',
    org_token_missing: 'The organization token is missing or could not be found.',
    otknid_is_none: 'A required value is missing. Refresh the page and try again.',
    trial_not_space_admin_tier: 'The trial is not space admin tier.',
    unidentifiable_org_request: 'The request could not be processed because a required identifier is missing.',
    vimeo_not_enabled: 'Vimeo is not enabled.'
})

export const dialogs = Object.freeze({
    space_limit_reached: {
        dialogTitle: "Can't create new space!",
        dialogText: 'The space limit has been reached. Remove an unused space or contact your administrator.',
        dialogAction: ['close']
    }
})
